function range(start: number, end: number): Array<number> {
  const ans = [];
  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

export default range;
